<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_319" data-name="Group 319" transform="translate(-35.342 -280.254)">
    <circle id="Ellipse_178" data-name="Ellipse 178" cx="35.201" cy="35.201" r="35.201" transform="translate(35.342 280.254)" fill="#fff"/>
    <path id="Path_277" data-name="Path 277" d="M3495.356,316.813h-21.027l-.288-1.119h0a2.113,2.113,0,0,0-2.088-1.591h-.02a2.111,2.111,0,0,0-2.079,1.624l-.26,1.086h-20.715v2.319h20.159l-3.776,15.758h-4.521v2.319h22.109V334.89h-3.87l-4.054-15.758h20.43Zm-23.561-.542h0Zm4.194,16.3H3468.2l3.22-13.439h1.108Z" transform="translate(-3401.575)" fill="#1a1818"/>
    <path id="Path_278" data-name="Path 278" d="M3457.557,305.877a3.9,3.9,0,0,0,.435-.256c.056-.037.108-.078.162-.118.092-.069.18-.142.265-.218a4.162,4.162,0,1,0-5.913-.542c.043.055.087.109.133.161.087.1.174.191.269.279a4.339,4.339,0,0,0,.385.318c.055.039.107.081.164.118a3.985,3.985,0,0,0,.439.258c-2.9,1.681-2.688,3.657-2.688,9.44H3462.8C3462.8,309.535,3460.576,306.658,3457.557,305.877Z" transform="translate(-3401.575)" fill="#1a1818"/>
    <path id="Path_279" data-name="Path 279" d="M3486.679,305.877a3.834,3.834,0,0,1-.435-.256c-.057-.037-.108-.078-.163-.118-.092-.069-.18-.142-.265-.218a4.162,4.162,0,1,1,5.913-.542c-.043.055-.087.109-.132.161-.087.1-.175.191-.27.279a4.17,4.17,0,0,1-.385.318c-.055.039-.107.081-.163.118a4.045,4.045,0,0,1-.44.258c2.9,1.681,2.688,3.657,2.689,9.44h-11.593C3481.435,309.535,3483.659,306.658,3486.679,305.877Z" transform="translate(-3401.575)" fill="#1a1818"/>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_03_a',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SC_02_03_a.vue